export enum MediaPlacementEnum {
  START = 'start',
  TOP = 'top',
  BOTTOM = 'bottom',
  PROFILE_PIC = 'profile_pic'
}